import type { AuthorFocusBook, Book, FreeChoiceBook, ScheduledBook, SpecificBook, TbaBook } from "./books.schema";

/**
 * Type guard to check if a book is a ScheduledBook
 * A book is considered scheduled if it has both month and year fields that are not null
 */
export function isScheduledBook(book: Book | ScheduledBook): book is ScheduledBook {
    // Check if book has month and year properties and they are not null
    return (
        "month" in book &&
        "year" in book &&
        book.month !== null &&
        book.month !== undefined &&
        book.year !== null &&
        book.year !== undefined
    );
}

export function isSpecificBook(book: Book): book is SpecificBook {
    return book.type === "specificBook";
}

export function isAuthorFocusBook(book: Book): book is AuthorFocusBook {
    return book.type === "authorFocus";
}

export function isFreeChoiceBook(book: Book): book is FreeChoiceBook {
    return book.type === "freeChoice";
}

export function isTbaBook(book: Book): book is TbaBook {
    return book.type === "tba";
}

export function isBookArchived(book: Book | ScheduledBook): boolean {
    return book.archivedAt != null;
}
